<template>
  <AssayDescriptionGrid :dv="dv" :fields="fields" />
  <TransmissionEMDatasetAcquisitionDetails :dv="dv" />
  <TomographyDetails v-if="showTomography" :dv="dv" />
</template>

<script>
import { useTomographyToggle } from '@/composables/validation/assay/useElectronMicroscopyValidation'
import AssayDescriptionGrid from '../shared/AssayDescriptionGrid.vue'
import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import TransmissionEMDatasetAcquisitionDetails from './TransmissionEMDatasetAcquisitionDetails.vue'
import TomographyDetails from './TomographyDetails.vue'

const fields = [
  ['name'],
  ['id'],
  ['state', 'slot:fc:is_template'],
  ['imaging_method'],
  ['tem_type', 'assay_temperature'],
  ['correlative_assay'],
  ['widget:instrumentData'],
  ['slot:fc:run_dir'],
  ['description'],
  ['nr_of_samples'],
  CUSTOM_PROPERTIES,
  ['protocol_list'],
]

export default {
  name: 'AssayTransmissionEM',
  components: {
    AssayDescriptionGrid,
    TransmissionEMDatasetAcquisitionDetails,
    TomographyDetails,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const { showTomography } = useTomographyToggle(props.dv)

    return { fields, showTomography }
  },
}
</script>
